<template>
  <div>
    <div ref="line" class="line-background">
      <!-- <div class="time-line" @click="adjustProgress($event)">
        <div class="progress-round" ref="progressRound">
          <div class="loading" ref="persentLoad" style="width: 0;"></div>
          <div class="progress" ref="progress" @click="adjustProgress"></div>
          <div class="round" ref="round" @mousedown="roundDrag"></div>
        </div>
      </div> -->
      <div class="progress-curve" ref="progressRound">
        <div class="curve-block height-15"></div>
        <div class="curve-block"></div>
        <div class="curve-block height-21"></div>
        <div class="curve-block height-6"></div>
        <div class="curve-block height-12"></div>
        <div class="curve-block height-7"></div>
        <div class="curve-block height-4"></div>
        <div class="curve-block height-6"></div>
        <div class="curve-block height-8"></div>
        <div class="curve-block height-15"></div>
        <div class="curve-block height-17"></div>
        <div class="curve-block height-21"></div>
        <div class="curve-block height-15"></div>
        <div class="curve-block"></div>
        <div class="curve-block height-21"></div>
        <div class="curve-block height-6"></div>
        <div class="curve-block height-12"></div>
        <div class="curve-block height-6"></div>
        <div class="curve-block height-12"></div>
        <div class="curve-block height-7"></div>
        <div class="curve-block height-4"></div>
        <div class="curve-block height-6"></div>
        <div class="curve-block height-8"></div>
        <div class="curve-block height-15"></div>
        <div class="curve-block height-17"></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "ProgressCurve",
  props: {
    presentT: {},
    totalT: {},
    persentLoad: { default: 0 }
  },
  data() {
    return {
      // 进度条拖拽
      dragClick: false,
      // 鼠标/手指按下
      clickDown: false,
      width: 0,
      pesent: 0,
      domList: []
    };
  },
  watch: {
    // 侦听当前播放时长设置进度条
    presentT: {
      handler(newValue) {
        // 未点击进度条
        const pesent = ((newValue / this.totalT) * 100) / 4;
        this.domList.forEach((el, index) => {
          if (index < pesent) {
            el.classList.add("active");
          } else {
            el.classList.remove("active");
          }
        });
      }
    }
  },
  mounted() {
    this.domList = document.querySelectorAll(".curve-block");
    window.addEventListener("resize", this.getWidth);
    this.$nextTick(() => {
      this.getWidth();
    });
  },
  beforeDestory() {
    window.removeEventListener("resize", this.getWidth);
  },
  methods: {
    getWidth() {
      const width = this.$refs.line.offsetWidth;
      this.width = width;
    },
    progressData(data) {
      this.$emit("changeCurrentTime", data);
      this.$emit("changeCurrentWord", data);
    },
    // 进度条位置和圆点定位处理
    dealWidth() {
      this.$refs.progress.style.width =
        (this.progressWidth / this.$refs.progressRound.offsetWidth) * 100 + "%";
      if (
        (this.progressWidth / this.$refs.progressRound.offsetWidth) * 100 -
          1.23 <
        0
      ) {
        // 圆点定位
        this.$refs.round.style.left = 0 + "%";
      } else {
        this.$refs.round.style.left =
          (this.progressWidth / this.$refs.progressRound.offsetWidth) * 100 -
          0 +
          "%";
      }
    },
    // 进度条点击
    adjustProgress(e) {
      this.dragClick = true;
      e.preventDefault();
      const { left, width } = this.$refs.progressRound.getBoundingClientRect(); // 进度条到屏幕距离及进度条的宽度
      this.progressWidth = e.clientX - left;
      if (this.progressWidth < 0) {
        //进度条边界值计算情况
        this.progressWidth = 0;
      } else if (this.progressWidth >= width) {
        this.progressWidth = width;
      } else {
        this.progressWidth = e.clientX - left; // e.clientX：鼠标点击的位置到屏幕最左侧的距离
      }
      this.dealWidth();
      this.progressData((this.progressWidth / width) * this.totalT);
    },
    // 进度条圆点拖拽
    roundDrag(event) {
      event.preventDefault();
      this.dragClick = true;
      this.clickDown = true; // 解决圆点拖拽进度条长度抖动
      document.onmousemove = e => {
        // 给圆点添加移动事件
        e.preventDefault(); // 阻止进度条拖拽时屏幕原有的滑动功能
        const X = e.clientX; // 获取圆点离屏幕的距离
        const {
          left,
          width
        } = this.$refs.progressRound.getBoundingClientRect();
        const ml = X - left; // 进度条长度：圆点离屏幕的距离减去进度条最左边离屏幕的距离
        if (ml <= 0) {
          // 进度条长度最小和最大值的界定
          this.progressWidth = 0;
        } else if (ml >= width) {
          this.progressWidth = width;
        } else {
          this.progressWidth = ml;
        }
        this.progressData((this.progressWidth / width) * this.totalT); //视频播放时间
        this.dealWidth();
      };
      // 抬起鼠标，结束移动事件
      document.onmouseup = () => {
        document.onmousemove = null;
        document.onmouseup = null;
        this.clickDown = false;
      };
    }
  }
};
</script>
<style lang="scss" scoped>
.progress-curve {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  transform: translateY(-7px) translateX(3px);
  .curve-block {
    width: 2px;
    // margin: 0px 1.5px;
    background-color: #7e7e7e;
    height: 9px;
    &.active {
      background-color: #525fff;
    }
  }
  .height-23 {
    height: 23px;
  }
  .height-21 {
    height: 21px;
  }
  .height-17 {
    height: 17px;
  }
  .height-15 {
    height: 15px;
  }
  .height-12 {
    height: 12px;
  }
  .height-8 {
    height: 8px;
  }
  .height-7 {
    height: 7px;
  }
  .height-6 {
    height: 6px;
  }
  .height-4 {
    height: 4px;
  }
}
.line-background {
  width: 100%;
  height: 4px;
  // background-color: rgba(255, 255, 255, 0.3);

  .time-line {
    width: 100%;
    height: 4px;
    background-color: #d8dce2;

    .progress-round {
      cursor: pointer;
      width: 100%;
      position: relative;
      display: flex;

      .loading {
        height: 4px;
        background-color: rgba(255, 255, 255, 0.3);
      }

      .progress {
        position: absolute;
        top: 0;
        left: 0;
        width: 00%;
        height: 4px;
        background-color: #525fff;
      }

      .round {
        position: absolute;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
        width: 4px;
        height: 12px;
        background: #525fff;
        border: 1px solid #f4f7fc;
      }
    }
  }
}
</style>
